import type { GreetingSetting, GreetingUpdate } from '@schwarz/contract';

import { apiSlice } from './api-slice.js';

/**
 * Console settings (S05).
 *
 * The greeting is the only one. It is shown on the outbound agent's page but
 * saved here, because it is the console's own configuration rather than a field
 * on the Sirma agent — see the note on the controller.
 */
export const settingsApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getGreeting: build.query<GreetingSetting, void>({
      query: () => ({ url: '/settings/greeting' }),
      providesTags: ['Setting'],
    }),

    updateGreeting: build.mutation<GreetingSetting, GreetingUpdate>({
      query: (body) => ({ url: '/settings/greeting', method: 'PUT', body }),
      invalidatesTags: ['Setting'],
    }),
  }),
});

export const { useGetGreetingQuery, useUpdateGreetingMutation } = settingsApi;

/**
 * The shared cache key for a greeting save, so the sidebar's mark turns for this
 * too. Same reasoning as the agent save — see `AGENT_SAVE_CACHE_KEY`.
 */
export const GREETING_SAVE_CACHE_KEY = 'greeting-save';
